import { TimeOffset } from '@travelity/api/generated';

export const timeOffsetToMinutes = (timeOffset: TimeOffset) => {
    const daysInMinutes = (timeOffset.days || 0) * 24;
    const hoursInMinutes = timeOffset.hours * 60;
    const minutes = timeOffset.minutes || 0;

    return daysInMinutes + hoursInMinutes + minutes;
};
